import React, { useEffect, useState } from 'react';

import { FileDto } from '../../documents/Document.interface';
import DocumentTemplateDialog from '../../documents/components/DocumentTemplateDialog';
import { Hazard, HazardExportEntity } from '../Hazard.interface';
import { useUpdateHazard } from '../Hazard.hooks';
import {
  getHazardTemplateFieldId,
  getHazardTemplateFieldName
} from '../Hazard.helpers';

export interface HazardAssignDocumentTemplateDialogProps {
  open: boolean;
  hazard: Hazard;
  assignEntity: HazardExportEntity;
  onCancel: () => void;
  onSuccess: (hazard: Hazard) => void;
}

const HazardAssignDocumentTemplateDialog: React.FC<HazardAssignDocumentTemplateDialogProps> = (
  props: HazardAssignDocumentTemplateDialogProps
) => {
  const { open, hazard, assignEntity, onCancel, onSuccess } = props;
  const {
    updatedHazard,
    updateError,
    isUpdating,
    updateHazard
  } = useUpdateHazard(hazard.id);
  const [selectedFile, setSelectedFile] = useState<FileDto | undefined>();

  const onAssign = (file: FileDto | undefined) => {
    const field = getHazardTemplateFieldId(assignEntity);
    updateHazard({ [field]: file?.id || null });
  };

  useEffect(() => {
    const field = getHazardTemplateFieldName(assignEntity);
    setSelectedFile(hazard[field]);
  }, [hazard, assignEntity]);

  useEffect(() => {
    updatedHazard && onSuccess(updatedHazard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedHazard]);

  return (
    <DocumentTemplateDialog
      hideUnsetButton
      open={open}
      file={selectedFile}
      error={updateError}
      isLoading={isUpdating}
      confirmLabel='Assign'
      title='Assign Document Template'
      setOpen={(open: boolean) => !open && onCancel()}
      onSelectFile={(file?: FileDto) => {
        setSelectedFile(file);
        onAssign(file);
      }}
    />
  );
};

export default HazardAssignDocumentTemplateDialog;
